import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TooltipDirective } from '@blaze-shared/shared-ui';
import { IconsModule } from '@blaze-shared/theming-data-access';

@Component({
  selector: 'blaze-table-triggers-warnings',
  imports: [TooltipDirective, IconsModule],
  templateUrl: './blaze-table-triggers-warnings.component.html',
  styleUrl: './blaze-table-triggers-warnings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlazeTableTriggersWarningsComponent {
  cycled = input<boolean>(false);
  disabled = input<boolean>(false);
}
